<template>
  <div class="main-container flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color ">
          <div class="vx-row padding no-gutter d-theme-dark-bg d-flex  flex-wrap " v-if="registrationFinish === 'register'">
            <div class="vx-col   lg:block flex-wrap sm:w-full md:w-full lg:w-2/5 max-width  mx-auto self-centerp p-5 pb-0 ">
              <div class="width-img-text vx-card__title mb-4 px-4 my-4 ">
                <h4 class="mb-4">Create Account</h4>
                <p>Fill the below form to create a new account.</p>
              </div>
              <div>
                <img src="@/assets/images/pages/register.jpg" alt="register" class=" width-img-text mx-auto ">
              </div>

              <div class=" flex-wrap " >
                <smsc-col-item >
                  <vs-input
                    v-validate="'required|alpha'"
                    data-vv-validate-on="input"
                    name="first name"
                    :class="{'is-danger': errors.has('first name')}"
                    type="text"
                    placeholder="Enter first name*"
                    v-model="payload.contact.first_name"
                    class="w-full   "/>
                  <span class="text-danger text-sm">{{ errors.first('first name') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    v-validate="'required|alpha'"
                    data-vv-validate-on="input"
                    name="last name"
                    :class="{'is-danger': errors.has('last name')}"
                    type="text"
                    placeholder="Enter last name*"
                    v-model="payload.contact.last_name"
                    class="w-full   "/>
                  <span class="text-danger text-sm">{{ errors.first('last name') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="input"
                    name="email"
                    :class="{'is-danger': errors.has('email')}"
                    type="email"
                    placeholder="Enter email*"
                    v-model="payload.contact.email"
                    class="w-full  "/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    v-validate="'required'"
                    data-vv-validate-on="input"
                    name="company name"
                    :class="{'is-danger': errors.has('company name')}"
                    type="text"
                    placeholder="Enter company name*"
                    v-model="payload.company_name"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('company name') }}</span>
                </smsc-col-item>
              </div>
            </div>
            <div class="vx-col   lg:block flex-wrap sm:w-full md:w-full lg:w-2/5  mx-auto self-centerp p-5 pt-0 ">
              <div class=" flex-wrap " >
                <smsc-col-item>
                  <vs-input
                    data-vv-validate-on="input"
                    name="address"
                    :class="{'is-danger': errors.has('address')}"
                    type="text"
                    placeholder="Enter address"
                    v-model="payload.contact.address"
                    class="w-full  "/>
                  <span class="text-danger text-sm">{{ errors.first('address') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    data-vv-validate-on="input"
                    name="city"
                    :class="{'is-danger': errors.has('city')}"
                    type="text"
                    placeholder="Enter city"
                    v-model="payload.contact.city"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    data-vv-validate-on="input"
                    name="state"
                    :class="{'is-danger': errors.has('state')}"
                    type="text"
                    placeholder="Enter state"
                    v-model="payload.contact.state"
                    class="w-full "/>
                  <span class="text-danger text-sm">{{ errors.first('state') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    v-validate="'required'"
                    data-vv-validate-on="input"
                    name="password"
                    :class="{'is-danger': errors.has('password')}"
                    type="password"
                    placeholder="Enter password*"
                    v-model="payload.contact.passwd"
                    class="w-full "/>
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    v-validate="'required'"
                    data-vv-validate-on="input"
                    name="re-enter password"
                    type="password"
                    :class="{'is-danger': errors.has('re-enter password')}"
                    placeholder="Re-enter passowrd*"
                    v-model="payload.contact.re_password"
                    class="w-full "/>
                  <span class="text-danger text-sm">{{ errors.first('re-enter password') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <!-- <vs-input-phone
                    v-model="phone_num"
                  /> -->
                  <div class="country-code">
                    <div class="flag">
                      <vue-country-code
                        class="country-code__dropdown"
                        @onSelect="SetCountryCode"
                      />
                      <span ref="phone-code" class="phone-code">{{ selected.phone_code }}</span>
                    </div>
                    <vs-input
                      ref="phone-input"
                      data-vv-validate-on="input"
                      name="phone"
                      :class="{'is-danger': errors.has('phone')}"
                      type="text"
                      v-model="payload.contact.phone"
                      class="w-full "/>
                    <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                  </div>
                </smsc-col-item>
                <smsc-col-item>
                  <vs-input
                    data-vv-validate-on="input"
                    name="zip code"
                    :class="{'is-danger': errors.has('zip code')}"
                    type="text"
                    placeholder="Enter zip code"
                    v-model="payload.contact.zipcode"
                    class="w-full "/>
                  <span class="text-danger text-sm">{{ errors.first('zip code') }}</span>
                </smsc-col-item>
                <smsc-col-item>
                  <v-select
                    data-vv-validate-on="input"
                    name="country"
                    :class="{'is-danger': errors.has('country')}"
                    placeholder="Select Country"
                    v-model="selected.country"
                    :options="countries"
                    :clearable="false"
                  />
                  <span class="text-danger text-sm">{{ errors.first('country') }}</span>
                </smsc-col-item>
              </div>
<!--              <div class="flex">-->
<!--                <div class="flex justify-center items-center">-->
<!--                  <vs-input-->
<!--                    data-vv-validate-on="input"-->
<!--                    name="one way sms"-->
<!--                    type="radio"-->
<!--                    class="one-way ml-5"-->
<!--                  />-->
<!--                  <span>One Way SMS</span>-->
<!--                </div>-->
<!--                <div class="flex justify-center items-center">-->
<!--                  <vs-input-->
<!--                    data-vv-validate-on="input"-->
<!--                    name="two way sms"-->
<!--                    type="radio"-->
<!--                    class="two-way ml-5"-->
<!--                  />-->
<!--                  <span>Two Way SMS</span>-->
<!--                </div>-->
<!--              </div>-->
              <div class="smsmc-footer flex justify-around w-100 pt-6 pb-6">
                <vs-button type="border" @click="$router.push({ name: 'login' })" class="ml-6">Login</vs-button>
                <vs-button class="float-right ml-6" @click="Register">Register</vs-button>
              </div>
            </div>
          </div>
          <div class="vx-row no-gutter d-theme-dark-bg" v-if="registrationFinish === 'pending'">
            <div class="vx-col  lg:block lg:w-3/4 d-theme-dark-bg mx-auto self-center p-5">
              <div class="vx-card__title mb-4 px-4">
                <h2 class="mb-8 text-center">Thank you for registering 🚀</h2>
                <div>You should be receiving a confirmation email with a verification
                  link. Please click the verification link to confirm your registration.
                </div>
                      <div class="smsmc-footer flex justify-around">
                          <vs-button class="float-right mr-2 mt-2" to="/pages/login">Go to Sign in</vs-button>
                      </div>
              </div>
              <img src="@/assets/images/pages/afterRegister.cbe7222a.svg" alt="register" class="mx-auto w-75">
            </div>
          </div>
          <div class="vx-row no-gutter d-theme-dark-bg" v-if="registrationFinish === 'success'">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-3/4 d-theme-dark-bg mx-auto self-center p-5">
              <div class="vx-card__title mb-4 px-4">
                <h2 class="mb-8 text-center">Welcom onboard!</h2>
                <div class="text-center">Your registration is confirmed. 🔐</div>
                <div class="smsmc-footer flex justify-around w-100 pt-6 pb-6">
                  <vs-button @click="$router.push({ name: 'login' })">Go to Sign in</vs-button>
                </div>
              </div>
              <img src="@/assets/images/pages/successRegister.700bd717.svg" alt="register" class="mx-auto w-100">
            </div>
          </div>
          <div class="vx-row no-gutter d-theme-dark-bg" v-if="registrationFinish === 'fail'">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-3/4 d-theme-dark-bg mx-auto self-center p-5">
              <div class="vx-card__title mb-4 px-4">
                <h2 class="mb-8 text-center">You are not authorized! 🔐</h2>
                <div class="text-center">It seems your verification code is invalid. Please try again.</div>
                <div class="smsmc-footer flex justify-around w-100 pt-6 pb-6">
                  <vs-button @click="registrationFinish = 'register'">Back to Registration</vs-button>
                </div>
              </div>
              <img src="@/assets/images/pages/failRegister.e9c47c33.svg" alt="register" class="mx-auto w-100">
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// Packages
import vSelect from 'vue-select'

import vsInputPhone from '@/components/VsInputPhone.vue'

export default {
  components: {
    vSelect,
    vsInputPhone
  },
  data() {
    return {
      registrationFinish: 'register',
      countries: [],
      products: [],
      selected: {
        country: null,
        phone_code: null
      },

      phone_num: '04177133766',

      // Request body
      payload: {
        contact: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          address: '',
          // country_uuid: null,
          state: '',
          city: '',
          zipcode: '',
          passwd: '',
          // logo_file_uuid: null,
          // full_name: null,
          // user_name: null,
          re_password: ''
        },
        company_name: null,
        product: [],
        // company_url: null
      }
    }
  },
  watch: {
    'payload.contact.first_name': function (val) {
      if (!val) {
        this.payload.contact.first_name = ''
        return
      }

      this.payload.contact.first_name = `${val.charAt(0).toUpperCase()}${val.slice(1)}`
    },
    'payload.contact.last_name': function (val) {
      if (!val) {
        this.payload.contact.last_name = ''
      }
      this.payload.contact.last_name = `${val.charAt(0).toUpperCase()}${val.slice(1)}`
    }
  },
  computed: {
    country_uuid() {
      return this.selected.country && this.selected.country.value
    }
  },
  created() {
    this.FetchData()
  },
  methods: {

    verifyRegister() {
      this.registrationFinish = 'success'
    },
    SetCountryCode(e) {
      this.selected.phone_code = `+${e.dialCode}`
      // this.$refs['phone-input'].$el.children[1].children[0].classList.remove('normal')
      // this.$refs['phone-input'].$el.children[1].children[0].style.paddingLeft = `${(String(e.dialCode).length * 8) + 61}px`
    },
    async FetchData() {
      this.$vs.loading()
      const {total: TotalForCountry} = await this.$store.dispatch('country/GetList', {per_page: 0})
      const {total: TotalForProduct} = await this.$store.dispatch('product/GetPublicProductList', {per_page: 0})
      const p1 = await this.$store.dispatch('country/GetList', {
        per_page: TotalForCountry,
        order_by: 'nice_name',
        order_dir: 'asc'
      })
      const p2 = await this.$store.dispatch('product/GetPublicProductList', {
        per_page: TotalForProduct,
        order_by: 'product_name',
        order_dir: 'asc'
      })

      Promise.all([p1, p2])
        .then(res => {
          this.countries = res[0].items.map(this.TransformCountry)
          this.products = res[1].items.map(this.TransformProduct)
        })
        .catch(err => this.ShowErrorMessage({title: 'Error fetch data', text: err}))
        .finally(() => this.$vs.loading.close())
    },
    async Register() {
        const valid = await this.$validator.validate()
        if (!valid) {
          return
        }
        this.payload.contact.country_uuid = this.country_uuid
      if(!this.country_uuid) {
        delete this.payload.contact.country_uuid
      }
      this.$vs.loading()
        this.$store.dispatch('auth/Register', {
          ...this.payload,
          contact: {...this.payload.contact, phone: `${this.selected.phone_code.slice(1)}${this.payload.contact.phone}`}
        })
          .then(res => {
            // console.log(res)
            if (res.success) {
              // this.$router.push({ name: 'login' })
              this.ShowSuccessMessage({title: 'Registration Attempt', text: 'Successfully registered'})
              this.registrationFinish = 'pending';
            } else {
              const err_message = res.errors
              this.$vs.notify({
                title: 'Registration Attempt',
                text: err_message,
                iconPack: 'feather',
                icon: 'iicon-alert-circle',
                color: 'danger'
              })
            }
          })
          .catch((err => this.ShowErrorMessage({title: 'Registration Attempt', text: err})))
          .finally(() => this.$vs.loading.close())

    },


    // Notify
    ShowSuccessMessage({title, text}) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage({title, text}) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformCountry(item) {
      return {
        label: item.nice_name,
        value: item.country_uuid
      }
    },
    TransformProduct(item) {
      return {
        name: item.product_name,
        value: item.product_uuid
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.verif-reg {
  color: #0d6efd;
  cursor: pointer;
}

.main-container {
  min-height: 100vh !important;
  // padding: 10% 0;

  .register-tabs-container {
    min-height: 517px;
  }
}

@media screen and (max-width: 1200px) and (min-width: 992px), screen and (max-width: 720px) {
  .main-container {
    padding: 10% 0;
  }
}
 @media (max-width: 991px) {
 .padding{
   padding: 20px!important;
 }
 }
   @media (max-width: 576px) {
 .max-width{
  max-width: 400px!important;
 }
  .width-img-text {
    max-width: 276px;

  }

 }
.one-way {
  margin-right: -80px;
}

.two-way {
  margin-right: -80px;
}

.country-code__dropdown {
  margin-top: -18px;
}

.phone-code {
  margin-top: -18px;
}

</style>
<style scoped>
  ::v-deep #vs1__listbox{

    height: 200px !important;
  }
  ::v-deep .vs__dropdown-menu{
    top:-200px!important;
    /*bottom: 100px!important;*/
  }

</style>
